module.exports = __webpack_public_path__ + "img/4c05e8b.svg";